import { ThemeEvents } from '@theme/events';

// Żądanie zapisu i aktualizację koszyka obsługuje istniejący product-form.js.
// Ten moduł dodaje wyłącznie blokadę powtórzenia oraz czytelny komunikat.
const init = () => {
  document.querySelectorAll('product-form-component[data-ryb-tile-cart]').forEach(component => {
    if (component.dataset.rybCartReady) return;
    component.dataset.rybCartReady = 'true';
    const form = component.querySelector('form');
    const button = component.querySelector('button[type="submit"]');
    const message = component.querySelector('[data-ryb-tile-message]');
    if (!form || !button || !message) return;
    let busy = false;
    let pendingTimer;
    const finish = (text, error) => {
      clearTimeout(pendingTimer);
      busy = false;
      button.disabled = false;
      component.removeAttribute('aria-busy');
      message.textContent = text;
      message.classList.toggle('is-error', error);
    };
    form.addEventListener('submit', event => {
      if (busy || button.disabled) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      busy = true;
      component.setAttribute('aria-busy', 'true');
      message.textContent = 'Dodawanie…';
      message.classList.remove('is-error');
      // Pozwala natywnemu handlerowi sprawdzić przycisk przed jego zablokowaniem.
      queueMicrotask(() => { if (busy) button.disabled = true; });
      pendingTimer = setTimeout(() => {
        // Brak potwierdzenia nie jest zgodą na ponowne wysłanie zamówienia.
        message.textContent = 'Brak potwierdzenia. Sprawdź koszyk przed ponowną próbą.';
        message.classList.add('is-error');
        component.removeAttribute('aria-busy');
      }, 20000);
    }, true);
    component.addEventListener(ThemeEvents.cartUpdate, event => {
      if (!busy || event.target !== component || event.detail?.data?.didError) return;
      finish('Dodano: ' + component.dataset.unitAdded + '.', false);
    });
    component.addEventListener(ThemeEvents.cartError, event => {
      if (!busy || event.target !== component) return;
      const description = event.detail?.data?.description;
      finish(typeof description === 'string' ? description : 'Nie udało się dodać produktu. Sprawdź dostępność.', true);
    });
  });
};
init();
document.addEventListener('shopify:section:load', init);
